import { render, staticRenderFns } from "./SubscriptionBoxOrderFraudReviewDetail.vue?vue&type=template&id=749d4304&lang=pug&"
import script from "./SubscriptionBoxOrderFraudReviewDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubscriptionBoxOrderFraudReviewDetail.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports